var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.market)?_c('b-img',{attrs:{"src":("/i18n/" + (_vm.market.toLowerCase()) + ".svg"),"alt":_vm.market,"title":_vm.market.toLocaleUpperCase(),"width":"20","height":"15"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }